import { RootState } from '@debbie/cortex/dist/reducer.js'
import { SubTabs } from '@debbie/iris/dist/components/index.js'
import {
  Webhook,
  Webhooks,
} from '@debbie/iris/dist/components/Webhooks/index.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router'

import API from './API.js'

const Developers = (props: {}) => {
  const lang = useSelector((s: RootState) => s.lang)
  const location = useLocation()

  return (
    <div>
      <SubTabs
        items={[
          {
            label: lang.navigation.settingsAPI,
            link: '/settings/developers',
          },
          {
            label: lang.navigation.settingsWebhooks,
            link: '/settings/developers/webhooks',
          },
        ]}
      />
      <Switch location={location}>
        <Route exact path="/settings/developers">
          <API />
        </Route>
        <Route exact path="/settings/developers/webhooks">
          <Webhooks basePath="/settings/developers/webhooks" />
        </Route>
        <Route exact path="/settings/developers/webhooks/:id">
          <Webhook />
        </Route>
      </Switch>
    </div>
  )
}

export default Developers
